<template>
  <v-menu bottom offset-y nudge-bottom="5" v-model="actionStatus">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        text
        v-on="on"
        v-bind="attrs"
        :disabled="count <= 0 && valueComputed === 'all' && !hasError"
        class="px-2"
      >
        <v-icon class="mx-2" small>mdi-{{ content.icon }}</v-icon>
        {{ content.text }}
        <span class="font-size-h6-sm ms-2">({{ persian(count) }})</span>
        <v-fade-transition mode="out-in">
          <v-icon class="ms-2" key="down" v-if="!actionStatus"
            >mdi-chevron-down</v-icon
          >
          <v-icon class="ms-2" key="up" v-else>mdi-chevron-up</v-icon>
        </v-fade-transition>
      </v-btn>
    </template>

    <v-list dense>
      <template v-for="(item, i) in itemsStatus">
        <v-list-item
          :key="i"
          v-if="item.value !== valueComputed"
          @click="updateValue(item.value)"
          color="primary"
          :disabled="item.disabled"
        >
          <v-list-item-icon :style="{ opacity: item.disabled ? 0.45 : 1 }">
            <v-icon>mdi-{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "commercialStatusFilter",

  props: {
    value: String,
    count: Number,
    hasError: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      actionStatus: false,
      itemsStatus: [
        {
          value: "all",
          text: "همه کدهای کیوآر",
          icon: "format-list-bulleted",
        },
        {
          value: "active",
          text: "کدهای کیوآر فعال",
          icon: "heart-pulse",
        },
        {
          value: "deactivate",
          text: "کدهای کیوآر غیرفعال",
          icon: "pause-circle-outline",
        },
        {
          value: "near",
          text: "کدهای کیوآر درحال انقضا",
          icon: "timer-alert-outline",
        },
        {
          value: "1",
          text: "کدهای کیوآر منقضی شده",
          icon: "lock-clock",
        },
      ],
    };
  },

  computed: {
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    content() {
      return this.itemsStatus.find((item) => item.value === this.valueComputed);
    },
  },

  methods: {
    updateValue(val) {
      this.valueComputed = val;
      this.actionStatus = false;
    },
    persian(number) {
      if (!number && number !== 0) return "";
      const persianNumbers = "۰۱۲۳۴۵۶۷۸۹";
      return number
        .toString()
        .split("")
        .map((d) => (/\d/.test(d) ? persianNumbers[d] : d))
        .join("");
    },
  },
};
</script>

<style scoped></style>
